//path: src\modules\timelineTransport\TimelineTransport.ts

import type { RendererBridge } from '@/modules/rendererBridge';
import { FrameCoalescer } from '@/common/frameCoalescer';

export class TimelineTransport {
  private snapshot: string = '[]';
  private lastSeek: { time: number; snapshot: string } | null = null;
  private readonly scrub = new FrameCoalescer<number>((time) => this.sendSeek(time));

  constructor(private readonly bridge: RendererBridge) {}

  setSnapshot(snapshot: string): void {
    this.snapshot = snapshot;
  }

  sendPlay(time: number): void {
    this.lastSeek = null;
    this.bridge.send({ type: 'timelinePlay', time, timelineSnapshot: this.snapshot });
  }

  sendPause(time: number): void {
    this.lastSeek = null;
    this.bridge.send({ type: 'timelinePause', time, timelineSnapshot: this.snapshot });
  }

  sendStop(time: number): void {
    this.lastSeek = null;
    this.bridge.send({ type: 'timelineStop', time, timelineSnapshot: this.snapshot });
  }

  sendSeek(time: number): void {
    if (this.lastSeek && this.lastSeek.time === time && this.lastSeek.snapshot === this.snapshot) return;
    this.lastSeek = { time, snapshot: this.snapshot };
    this.bridge.send({ type: 'timelineSeek', time, timelineSnapshot: this.snapshot });
  }

  scrubTo(time: number, frameWindow?: Window): void {
    this.scrub.schedule(time, frameWindow);
  }

  endScrub(time: number): void {
    this.scrub.flush(time);
  }
}
